<script>
import { orderBy, find } from 'lodash';

export default {
  props: ['value'],
  mounted() {
    this.templateAnswer = find(this.templates, { value: this.templateAnswerSelect });
  },
  data() {
    return {
      templates: null,
      templateAnswerSelect: null,
      modalView: 'templates',
      templateAnswer: null,
    };
  },
  created() {
    this.templates = orderBy(this.value.templateList, [(item) => item.text.toLowerCase()]);
  },
  watch: {
    templateAnswerSelect(v) {
      this.templateAnswer = find(this.templates, { value: v });
      this.modalView = 'template';
    },
  },
  methods: {
    setTemplate(template) {
      this.value.addTemplate(template);
      this.close();
    },
    close() {
      this.$parent.close([null]);
    },
  },
};
</script>

<template lang="pug">
div(:class="$style.root")
  header
    div(:class="$style.header")
      div(:class="$style.title") {{ value.header }}
      div(:class="$style.icon", @click="close",
        tabindex="0", @keyup.enter="close")
        ui-icon(:class="$style.close", key="close", title="Закрыть" data-test="CLOSE_BUTTON") close
    div(:class="$style.line")
  div(:class="[$style.content]")
    v-select(:class="$style.select",
      :items="templates",
      v-model="templateAnswerSelect",
      :menu-props="{ zIndex: 10009 }"
      :label="$t('T_SELECT_TEMPLATE')")
    div(:class="$style.container")
      div(:class="$style.templates" v-if="modalView === 'templates'")
        div(:class="$style.template", :key="template.id",  v-for="(template, index) in templates")
          div(:class="$style.description") {{template.value}}
          div(:class="$style.action")
            ui-button(:class="[$style.actionsShape, $style.send]",
              colored="primary",
              @click.native="setTemplate(template)",
              @keyup.enter.native="setTemplate(template)")
              span(:class="$style.text") Привязать шаблон
      div(:class="$style.templates" v-if="modalView === 'template'")
        div(:class="$style.template")
          div(:class="$style.description") {{templateAnswer.value}}
          div(:class="$style.action")
            ui-button(:class="[$style.actionsShape, $style.send]",
              colored="primary",
              @click.native="setTemplate(templateAnswer)",
              @keyup.enter.native="setTemplate(templateAnswer)")
              span(:class="$style.text") Привязать шаблон
</template>

<style lang="sass" module>
.templates
  display: flex
  flex-direction: column
  padding-top: 16px
  flex-shrink: 0
.template
  display: flex
  align-items: center
  .action
    display: flex
    flex: 1 1 20%
  .description
    padding: 0 8px 12px
    color: $color_text
    font-weight: 400
    font-size: 16px
    text-overflow: ellipsis
    word-break: break-all
    word-wrap: break-word
    margin-top: 16px
    flex: 4
    &.disabled
      cursor: default
      opacity: 0.7
.header
  display: flex
.root
  display: block
  margin: 24px
  width: 600px
.title
  display: flex
  justify-content: center
  font-size: 18px
  font-weight: 400
  padding-bottom: 8px
  align-items: center
  flex-grow: 1
.subTitle
  display: flex
  justify-content: flex-start
  font-size: 16px
  font-weight: 400
  padding: 8px 0
  &.center
    justify-content: center
.line
  border-bottom: 1px solid $color_divider
  margin: 8px 0
.select
  padding-bottom: 0px
.content
  height: 500px
  display: flex
  flex-direction: column
  min-width: 484px
  margin-bottom: 16px
  opacity: 1
  transition: height $a_hide_slow, opacity $a_speed
  .text
    color: $white
  .actions
    display: flex
    justify-content: flex-start
    flex-wrap: wrap
    &Shape
      padding: 0 8px
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      display: flex
      justify-content: flex-start
      cursor: pointer
      margin-right: 8px
      margin: 8px 8px 0 0
      &.send
        border-radius: 2px
        display: flex
        flex: 1 1 100%
  .container
    overflow: auto
    margin: 40px 0 20px
    padding: 0
    height: 450px
  &.hide
    height: 80px
    opacity: 0
.action
  display: flex
  padding: 24px
  justify-content: space-around
.icon
  width: 36px
  height: 36px
  display: flex
  align-items: center
  justify-content: center
  border-radius: 50%
  cursor: pointer
  &:hover
    background: $color_main_light_third
    color: $color_msg_dark
  &:focus
    background: $color_main_light_third
    color: $color_msg_dark
    outline: none
  .close
    width: 70%

</style>
